import React from 'react';
import { Link } from 'react-router-dom';

const Services: React.FC = () => {
  const services = [
    {
      id: 1,
      icon: "🏠",
      title: "Konut Projeleri",
      description: "Villa, daire ve site projelerinde modern ve konforlu yaşam alanları tasarlıyoruz.",
      features: ["Villa tasarımı", "Apartman planlaması", "Site master planı", "İç mekan tasarımı"]
    },
    {
      id: 2,
      icon: "🏢",
      title: "Ticari Mekanlar",
      description: "Ofis, mağaza ve restoran gibi ticari alanlar için fonksiyonel çözümler.",
      features: ["Ofis tasarımı", "Mağaza konsepti", "Restoran iç mekanı", "Showroom tasarımı"]
    },
    {
      id: 3,
      icon: "🏗️",
      title: "Restorasyon",
      description: "Tarihi binaların korunarak modern ihtiyaçlara uygun şekilde yenilenmesi.",
      features: ["Tarihi yapı analizi", "Koruma projeleri", "Yenileme çalışmaları", "Dokümantasyon"]
    },
    {
      id: 4,
      icon: "📐",
      title: "3D Modelleme",
      description: "Yüksek kaliteli 3D modeller ve fotorealistik renderlar.",
      features: ["3D modelleme", "Fotorealistik rendering", "Sanal tur", "Animasyon"]
    },
    {
      id: 5,
      icon: "📋",
      title: "Teknik Çizim",
      description: "Detaylı teknik çizimler ve uygulama projeleri.",
      features: ["Mimari projeler", "Uygulama projeleri", "Detay çizimleri", "Rölöve çalışmaları"]
    },
    {
      id: 6,
      icon: "🎨",
      title: "Grafik Tasarım",
      description: "Logo, kurumsal kimlik ve dijital tasarım hizmetleri.",
      features: ["Logo tasarımı", "Kurumsal kimlik", "Web tasarımı", "Mobil uygulama UI/UX"]
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content fade-in-up">
          <div className="accent-line" style={{margin: '0 auto var(--spacing-sm)'}}></div>
          <h1 className="display-2 hero-title">Hizmetler</h1>
          <p className="body-large hero-description">
            Mimari tasarımdan 3D görselleştirmeye, kapsamlı hizmet yelpazesi
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section">
        <div className="container">
          <div className="grid grid-3">
            {services.map((service, index) => (
              <div key={service.id} className={`card fade-in-up animate-delay-${(index % 4) + 1}`} style={{padding: 'var(--spacing-md)'}}>
                <div style={{fontSize: '3rem', marginBottom: 'var(--spacing-md)'}}>{service.icon}</div>
                <h3 className="heading-3 mb-sm">{service.title}</h3>
                <p className="body-base text-secondary mb-md">{service.description}</p>
                <ul style={{listStyle: 'none', padding: 0}}>
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="body-small text-secondary" style={{marginBottom: 'var(--spacing-xs)'}}>
                      <span className="accent-text">•</span> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section-sm" style={{background: 'var(--color-bg-card)'}}>
        <div className="container">
          <div className="text-center mb-xl">
            <div className="accent-line" style={{margin: '0 auto var(--spacing-sm)'}}></div>
            <h2 className="heading-1">Çalışma Süreci</h2>
          </div>
          <div className="grid grid-4">
            {[
              { step: "01", title: "Görüşme", desc: "İhtiyaçlarınızı dinliyor ve projenizi anlıyoruz" },
              { step: "02", title: "Konsept", desc: "Yaratıcı fikirler ve konsept tasarımlar geliştiriyoruz" },
              { step: "03", title: "Tasarım", desc: "Detaylı projeler ve 3D görselleştirmeler hazırlıyoruz" },
              { step: "04", title: "Uygulama", desc: "Teknik çizimler ve uygulama desteği sağlıyoruz" }
            ].map((item, index) => (
              <div key={index} className="card" style={{padding: 'var(--spacing-md)', textAlign: 'center'}}>
                <p className="display-2 accent-text mb-sm">{item.step}</p>
                <h3 className="heading-3 mb-sm">{item.title}</h3>
                <p className="body-small text-secondary">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div className="container">
          <div className="text-center">
            <h2 className="heading-1 mb-md">Projenize Başlayalım</h2>
            <p className="body-large text-secondary mb-lg">
              Ücretsiz danışmanlık için hemen iletişime geçin
            </p>
            <div className="flex-center gap-md">
              <Link to="/projeler" className="btn btn-outline">
                Projelerimizi İnceleyin
              </Link>
              <a href="/#iletisim" className="btn btn-primary">
                İletişime Geçin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
